import {Button} from "@mui/material";
import styled from "@emotion/styled";

export const PureButton = styled(Button)`
	padding: 0;
	margin: 0;
	min-width: unset;
`;

export const PrimaryButton = styled(PureButton)`
	width: 100%;
	font-style: normal;
	font-size: 16px;
	display: flex;
	align-items: center;
	text-transform: uppercase;
	padding: 10px 16px;
	-webkit-border-radius: 22px;
	-moz-border-radius: 22px;
	border-radius: 22px;
	border: 1px solid ${({theme}) => theme.buttons.primary.default.borderColor};
	transition: 0.25s;

	background: ${({theme}) => theme.buttons.primary.default.background};
	color: ${({theme}) => theme.buttons.primary.default.color};
	font-family: ${({theme}) => theme.fonts.primary};

	&:hover,
	&:focus,
	&:active,
	&.active {
		background: ${({theme}) => theme.buttons.primary.hover.background};
		color: ${({theme}) => theme.buttons.primary.hover.color};
		border-color: ${({theme}) => theme.buttons.primary.hover.borderColor};
		cursor: pointer;
	}

	&:disabled {
		background: ${({theme}) => theme.buttons.primary.disabled.background};
		color: ${({theme}) => theme.buttons.primary.disabled.color};
		opacity: ${({theme}) => theme.buttons.primary.disabled.opacity};
		border-color: ${({theme}) => theme.buttons.primary.disabled.borderColor};
		pointer-events: none;
		cursor: default;
	}

	&.white {
		color: ${({theme}) => theme.buttons.primary.default.background};
		background: ${({theme}) => theme.buttons.primary.default.color};
		border-color: ${({theme}) => theme.buttons.primary.default.color};
	}
`;

export const SecondaryButton = styled(PrimaryButton)`
	background: ${({theme}) => theme.buttons.secondary.default.background};
	color: ${({theme}) => theme.buttons.secondary.default.color};
	border-color: ${({theme}) => theme.buttons.secondary.default.borderColor};
	font-family: ${({theme}) => theme.fonts.secondary};

	&:hover,
	&:focus,
	&:active,
	&.active {
		background: ${({theme}) => theme.buttons.secondary.hover.background};
		color: ${({theme}) => theme.buttons.secondary.hover.color};
		border-color: ${({theme}) => theme.buttons.secondary.hover.borderColor};
		cursor: pointer;
	}

	&:disabled {
		background: ${({theme}) => theme.buttons.secondary.disabled.background};
		color: ${({theme}) => theme.buttons.secondary.disabled.color};
		opacity: ${({theme}) => theme.buttons.secondary.disabled.opacity};
		border-color: ${({theme}) => theme.buttons.secondary.disabled.borderColor};
		pointer-events: none;
		cursor: default;
	}
`;

export const OutlinedButton = styled(PrimaryButton)`
	background: ${({theme}) => theme.buttons.outline.default.background};
	color: ${({theme}) => theme.buttons.outline.default.color};
	border-color: ${({theme}) => theme.buttons.outline.default.borderColor};
	font-family: ${({theme}) => theme.fonts.primary};

	&:hover,
	&:focus,
	&:active,
	&.active {
		background: ${({theme}) => theme.buttons.outline.hover.background};
		color: ${({theme}) => theme.buttons.outline.hover.color};
		border-color: ${({theme}) => theme.buttons.outline.hover.borderColor};
		cursor: pointer;
	}

	&:disabled {
		background: ${({theme}) => theme.buttons.outline.disabled.background};
		color: ${({theme}) => theme.buttons.outline.disabled.color};
		opacity: ${({theme}) => theme.buttons.outline.disabled.opacity};
		border-color: ${({theme}) => theme.buttons.outline.disabled.borderColor};
		pointer-events: none;
		cursor: default;
	}
`;
